import * as React from "react";
import {useEffect, useState} from "react";
import {
  Button,
  Grid,
} from "@material-ui/core";
import {createStyles, createTheme, makeStyles, Theme, ThemeProvider, withStyles,} from "@material-ui/core/styles";
import useStyles from "../assets/styles";
import { useHistory } from 'react-router-dom';
import { AddnewProductVersion } from "./AddnewProductVersion";

const theme = createTheme({
  typography: {
    fontFamily: "'Poppins', sans-serif",
  },
});

export function OTAManagerComponent() {
  const classes = useStyles();
  const history = useHistory();

  const closePopUp = () => {
    history.push('/');
  }

  return (
    <ThemeProvider theme={theme}>
      <div className={`testing`} >
               <Grid container alignItems="center" >
          <Grid item xs={12} md={12} style={{ textAlign: "center", paddingTop: "50px", paddingBottom: "40px" }}>
            <h4>OTA Manager</h4>
          </Grid>
        </Grid>
        <Grid className={classes.AddversionContainer}>
         <AddnewProductVersion 
          goBack={closePopUp}/>
          </Grid>

      </div>
      </ThemeProvider>
  );
}

